module.exports = __webpack_public_path__ + "static/media/404.5b54d0ba.jpg";